import {
  type Environment,
  type RecordSourceSelectorProxy,
} from "relay-runtime";

import type { Record } from "relay-runtime/lib/store/RelayStoreTypes";

// Type for accessing Relay's internal _records property
export interface RelaySourceWithRecords {
  _records: Map<string, Record>;
}

/**
 * Finds all connection IDs in a Relay store for a given connection key and parent record
 * @param relayEnvironment - The Relay environment containing the store
 * @param connectionKey - The connection key to search for (e.g., "GroupsTable_roleAssignments")
 * @param parentId - The parent record ID to search within (e.g., "client:root")
 * @returns Array of connection record IDs that match the connection key
 */
export function findAllConnectionIds(
  relayEnvironment: Environment,
  connectionKey: string,
  parentId: string,
) {
  const ids: string[] = [];
  // Cast to access the undocumented _records property
  const value = (
    relayEnvironment.getStore().getSource() as unknown as RelaySourceWithRecords
  )._records.get(parentId);

  if (value !== undefined) {
    Object.entries(value).forEach(function (param) {
      if (param[0].startsWith("__" + connectionKey + "_connection")) {
        // Type guard to ensure param[1] has the expected structure
        const connectionValue = param[1] as Record;
        if (
          typeof connectionValue === "object" &&
          connectionValue &&
          "__ref" in connectionValue
        ) {
          const ref = connectionValue.__ref;
          if (typeof ref === "string") {
            ids.push(ref);
          }
        }
        return;
      }
    });
  }
  return ids;
}

/**
 * Finds all connection IDs and invalidates them in the Relay store
 * @param relayEnvironment - The Relay environment
 * @param connectionKey - The connection key to search for
 * @param parentId - The parent record ID to search within
 * @param store - The Relay store from the updater function
 */
export function invalidateConnections(
  relayEnvironment: Environment,
  connectionKey: string,
  parentId: string,
  store: RecordSourceSelectorProxy,
) {
  const ids = findAllConnectionIds(relayEnvironment, connectionKey, parentId);

  ids.forEach((id) => {
    const record = store.get(id);
    if (record) {
      record.invalidateRecord();
    }
  });
}
